import * as Yup from 'yup';

export const eventSchema = Yup.object({
    newsroomId: Yup.string().optional().nullable(),
    title: Yup.object({
        es: Yup.string().required('El título en español es requerido'),
        en: Yup.string().optional().nullable(),
        pt: Yup.string().optional().nullable()
    }).required('El título es requerido'),
    host: Yup.object({
        id: Yup.string().required('El ID del anfitrión es requerido'),
    }).required('El anfitrión es requerido'),
    game: Yup.object({
        id: Yup.string().optional().nullable(),
    }).optional().nullable(),
    description: Yup.object({
        es: Yup.string().required('La descripción en español es requerida'),
        en: Yup.string().optional().nullable(),
        pt: Yup.string().optional().nullable()
    }).required('La descripción es requerida'),
    link: Yup.string().optional().nullable(),
    slug: Yup.string().required('El slug es requerido'),
    coverImage: Yup.object({
        es: Yup.string().required('La imagen de portada en español es requerida'),
        en: Yup.string().optional().nullable(),
        pt: Yup.string().optional().nullable()
    }).required('La imagen de portada es requerida'),
    notifyRescheduled: Yup.boolean().optional().nullable(),
    startsAt: Yup.string().required('La fecha de inicio es requerida'),
    endsAt: Yup.string().optional().nullable(),
    expiresAt: Yup.string().nullable(),
    status: Yup.string()
        .oneOf(['draft', 'published', 'canceled'])
        .required('El estado es requerido'),
    location: Yup.string().optional().nullable(),
    cta: Yup.object({
        es: Yup.object({ text: Yup.string().optional().nullable(), link: Yup.string().optional().nullable() }).optional().nullable(),
        en: Yup.object({ text: Yup.string().optional().nullable(), link: Yup.string().optional().nullable() }).optional().nullable(),
        pt: Yup.object({ text: Yup.string().optional().nullable(), link: Yup.string().optional().nullable() }).optional().nullable()
    }).optional().nullable(),
})